import React from 'react';
import { LinearProgress } from '@material-ui/core';
import { BackButton } from '../../components/AtomComponents';
import { useConfirm } from '../../context/ConfirmContext';
import useFederatedLogin from './useFederatedLogin';
import { FederatedLoginForm } from './FederatedLoginForm';
import { FederatedLoginResult } from './FederatedLoginResult';
import './FederatedLogin.scss';

const FederatedLogin: React.FC = () => {
  const { confirm } = useConfirm();
  const federatedLogin = useFederatedLogin();
  const { formData, loading, loginUrl, generateUrl } = federatedLogin;

  const onSubmit = (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    confirm({
      content: (
        <>
          Are you sure you want to generate AWS Federated Login URL for Jira Ticket:{' '}
          <b>{formData.jiraTicket.trim()}</b>?
        </>
      ),
      confirmText: 'Generate URL',
      cancelText: 'Cancel',
      onConfirm: generateUrl,
    });
  };

  return (
    <div className="px-FederatedLogin">
      <div className="cell small-12 px-one-line-data margin-bottom-2">
        <BackButton />
        <h3 className="small-12 margin-bottom-1">Federated Login</h3>
      </div>

      <div className="federated-login-card">
        <FederatedLoginForm
          formState={federatedLogin}
          handlers={federatedLogin}
          onSubmit={onSubmit}
        />

        {loading && (
          <div className="loading-container">
            <LinearProgress color="primary" />
            <div className="loading-text">Generating AWS federated login URL, please wait...</div>
          </div>
        )}

        {loginUrl && !loading && <FederatedLoginResult loginUrl={loginUrl} />}
      </div>
    </div>
  );
};

export default FederatedLogin;
